import React, { useState } from 'react';

const CreateModule = ({ formData, selectedCourse, handleAddModule, handleChange }) => {

    return (
        <>
            <h2 className="text-2xl font-bold mb-4">Add Module for {selectedCourse.name}</h2>
            <form onSubmit={handleAddModule} className="mb-6">
                <div className="mb-4">
                    <label className="block text-gray-700">Sort Order Id</label>
                    <input
                        type="text"
                        name="sort_order"
                        value={formData.sort_order}
                        onChange={handleChange}
                        className="border w-full p-2"
                        placeholder="Enter Sort Order"
                    />
                </div>
                <input
                    type="text"
                    name="moduleTitle"
                    value={formData.moduleTitle}
                    onChange={handleChange}
                    placeholder="Module Title"
                    className="border border-gray-300 p-2 rounded mb-4 w-full"
                />
               
                <button type="submit" className="bg-green-600 text-white px-3 py-2 rounded hover:bg-green-700">
                    Add Module
                </button>
            </form>
        </>
    );
};

export default CreateModule;